import FilterListIcon from '@mui/icons-material/FilterList';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';

/**
 * Creates a menu item to add a module filter for ModelModuleChip components
 * @param moduleReferenceDesignator - The module reference designator to filter by
 * @param handleAddModuleFilter - The callback function to handle adding the module to the filter
 * @returns Function that renders the menu item with closeMenu callback, or function that returns null if handleAddModuleFilter is not provided
 */
export function createModuleFilterMenuItem(
	moduleReferenceDesignator: string,
	handleAddModuleFilter?: (moduleReferenceDesignator: string) => void,
): (closeMenu: () => void) => React.ReactNode {
	if (!handleAddModuleFilter) {
		return () => null;
	}

	// This is a render function, not a React component, so we disable React component rules
	// eslint-disable-next-line react/display-name, react/function-component-definition
	return (closeMenu: () => void) => (
		<MenuItem
			key='add-to-filter'
			onClick={() => {
				handleAddModuleFilter(moduleReferenceDesignator);
				closeMenu();
			}}
		>
			<ListItemIcon>
				<FilterListIcon />
			</ListItemIcon>
			<ListItemText>Add to Design Object Filter</ListItemText>
		</MenuItem>
	);
}
